export const getBoard = ({ cart = [], dataSource, storeCart = [] } = {}) =>
  new Promise((resolve, reject) => {
    const counts = storeCart.reduce((total, item) => ({ ...total, [item]: (total[item] || 0) + 1 }), {});

    const findBoard = (id) =>
      dataSource.items
        .map(({ boards = [], name: roomName }) => boards.map((board) => ({ ...board, roomName })))
        .flat()
        .find((board) => board.id === id);

    const board = findBoard(storeCart[cart.length]);

    if (storeCart.length === cart.length || !board || counts[board.id] > board.maxSelected) return reject();
    else return resolve(board);
  });
